export enum AssemblyTypeEnum {
  AutomaticSingle = 'AutomaticSingle',
  AutomaticMerge = 'AutomaticMerge',
  ManualMerge = 'ManualMerge',
}

export const allAssemblyTypes = Object.keys(AssemblyTypeEnum);
